// extracted by mini-css-extract-plugin
export default {"loading_container":"List_loading_container__KMXtT","message_list":"List_message_list__+T1NF","loading":"List_loading__YtZR2"};